(() => {
  if (window.beginnerProductDisclosureInitialized) return;
  window.beginnerProductDisclosureInitialized = true;

  const closeDisclosure = (disclosure, restoreFocus = false) => {
    if (!disclosure) return;

    disclosure.removeAttribute('open');

    if (restoreFocus) {
      disclosure.querySelector('summary')?.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-beginner-products-close]');

    if (closeButton) {
      closeDisclosure(closeButton.closest('.beginner-hero__product-disclosure'), true);
      return;
    }

    document.querySelectorAll('.beginner-hero__product-disclosure[open]').forEach((disclosure) => {
      if (!disclosure.contains(event.target)) {
        closeDisclosure(disclosure);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.beginner-hero__product-disclosure[open]').forEach((disclosure) => {
      closeDisclosure(disclosure, true);
    });
  });
})();
